const vi = {

    '公告': "Thông báo",
    '公告管理': "Quản lí thông báo",
    '添加公告': "Thêm thông báo",
    '排序': "Số thứ tự",
    '标题': "Đề muc",
    '是否首页弹出显示': "Chắc chắn muốn gắn hiển thị lên trang đầu chứ ?",
    'banner图': "Ảnh",
    '详情图': "Ảnh chi tiết",
    '操作': "Thao tác",
    '是': "Đồng ý",
    '否': "Không đồng ý",
    '编辑': "Chỉnh sửa",
    '删除': "Xóa",
    '开头重要通知': "Bắt đầu thông báo quan trọng",
    '普通文字内容': "Nội dung văn bản bình thường",
    '结尾重要通知': "Kết thúc thông báo quan trọng",
    '本账号': "Tài khoản này",
    '验证码错误或者超时': 'Mã xác nhận sai hoặc quá hạn',

    '手机号码已经被占用,请更换手机号': 'Số điện thoại này đã tồn tại, vui lòng đổi số khác',

    "在线咨询": "Tư vấn trực tuyến",
    "下载客户端": "Tải ứng dụng",
    "立即下载": "Tải xuống ngay",
    "用户提示": "Lời nhắc cho người chơi",
    "点击屏幕右上角": "Nhấn vào góc trên bên phải của màn hình",
    "选择在Safari中打开": "Chọn mở trong Safari",
    "安卓": "Android",
    "请使用Iphone设备下载": "Sử dụng thiết bị Iphone để tải về",

    '暂时不能交易[1001]': 'Tạm thời không thể giao dịch',
    '无效的邀请码': 'Mã mời không có hiệu lực',
    '无效访问，请重新登录': 'Mất kết nối, mời đăng nhập lại',
    '发送': "Gửi đi",
    '手机,昵称,姓名': "Số điện thoại, Tên riêng, Họ tên",

    '无效访问，请重新登录': "Không có phản hồi, mời đăng nhập lại",

    '管理员': "quản trị viên",
    '代理商': "Đại lí",
    '客户': "Khách hàng",
    '正常': "Bình thường",
    '已注销': "Đã đăng xuất",
    '个': "Cái",
    '当前净值': "Vốn sở hữu hiện tại",
    '当前浮动盈亏': "Biễn động lãi lỗ hiện tại",

    '添加子账户': "Thêm tài khoản con",
    '用户名': "Tên người dùng",
    '权限管理': "Quyền quản lí",
    '修改下级客户': "Sửa đổi thông tin cấp dưới ",
    '删除': "Xoá",
    "所有聊天": "Toàn bộ cuộc thoại",
    "欢迎使用": "Mời sử dụng",
    "发给": "Gửi đi",
    '出金成功，等待管理员审核': "Rút thành công, vui lòng chờ xét duyệt",


    '更新信息成功': "Sửa đổi thông tin thành công",
    '时间类型': "Thời gian",
    '平仓委托已市价成交': "Đóng lệnh thành công",
    '市价': "Giá thị trường",
    '限价': "Gía giới hạn",
    '操作过于频繁': "thao tác nhiều lần không hợp lệ",
    '聊天': "Trò chuyện",

    '剩余可用资金不足，无法出金': "số dư khả dụng không đủ, không thể tiền hành mua",
    '验证码不正确': "Mã xác minh không đúng hoặc quá hạn",

    '入金最少': "Rút tối thiểu",
    '入金最多': "Rút tối đa",
    '出金金额过小': "Số tiền rút nhỏ hơn giới hạn rút",
    '出金金额过大': "Số tiền rút lớn hơn giới hạn rút",

    '审核完成': "Xét duyệt hoàn thành",
    '推广开户': "Thúc đẩy mở tài khoản",
    '分组': "Chia nhóm",
    '邀请码': "Mã mời",
    '开户链接': "Liên kết tài khoản",
    '修改密码成功': "Sửa đổi mật khẩu thành công",
    '地区': "Khu vực",
    '身份证': "Chứng minh thư",
    '银行卡': "Thẻ ngân hàng",
    '激活客户': "Kích hoạt khách ",
    '未激活客户': "Chưa kích hoạt khách",
    '转账': "chuyển khoản",
    '平仓表单不完整': "Biểu bán không đầy đủ",
    '平仓量超出限制': "Số lượng bán vượt giới hạn xuất",
    '是否确认平仓': "Xác nhận sẽ bán ?",
    '修改信息': "Sửa đổi thông tin",
    '昵称': "Tên nick",
    '平仓委托已市价提交': "Đơn vị đóng đã gửi theo giá thị trường",
    '认购成功': "Mua thành công",
    '可用资金不足，请充值后在进行认购': "Số dư không đủ, vui lòng nạp thêm",
    '手数不合理，请重新输入': "Kích thước lô không đúng,vui lòng nhập lại",
    '入金状态': "Trạng thái nạp tiền",
    '出金状态': "Trạng thái rút tiền",
    '请选择出金状态': "Mời chọn trạng thái rút tiền",

    '盈利': "Lợi nhuận",
    '亏损': "Thua lỗ",
    '保证金清空': "Làm mới tiền bảo đảm",
    '驳回出金': "Trả về tiền rút",
    '平仓手续费': "Phí bán ",
    '申请出金': "Nộp đơn rút tiền",

    '总入金': "Tổng nạp",
    '总出金': "Tổng rút",
    '出金id': "ID rút",
    '入金id': "ID nạp",
    '保证金总额': "Tổng tiền đảm bảo",
    '保证金变动': "Biến động tiền đảm bảo",
    '手续费': "Phí giao dịch",
    '正常入金': "Nhập khoản bình thường",
    '库存费': "Phí kiểm kê",
    '正常出金': "Xuất khoản bình thường",

    '客户信息': "Thông tin khách hàng",
    '上级': "Cấp trên",
    '返佣等级': "Cấp độ hoàn trả",
    '通过': "Thông qua",
    '手动入金': "Thêm tiền thủ công",
    '支付订单号': "Mã thanh toán",
    '申请时间': "Thời gian nộp đơn",
    '审核时间': "Thời gian duyệt đơn",
    '手动出金': "Xuất tiền thủ công",

    '登录成功': "Đăng nhập thành công",
    '登陆成功': "Đăng nhập thành công",
    '账号或密码错误': "Tài khoản hoặc mật khẩu không đúng",
    '验证码错误或超时': "Mã xác nhận sai hoặc quá hạn",
    '账号注册成功': "Đăng kí tài khoản thành công",
    '实名认证': "Xác minh danh tính",

    '入金最少100元': 'Số lượng nạp thấp nhất là 500.000VND',
    '场外USDT入金': 'Nạp tiền bằng USDT',
    '将会把您的USDT购买订单发送给NEWMONEY场外数字货币交易平台，NEWMONEY将会自动匹配一位USDT卖家给您，您只需要根据卖家提供的银行卡信息转账给该卖家，等待卖家确认收到您的法币之后，卖家将会自动把该笔USDT释放给': 'Đơn mua USDT của bạn sẽ được gửi tới sàn giao dịch tiền ảo NEWMONEY, sàn sẽ tự động khớp lệnh mua USDT của người bán cho bạn. Bạn chỉ cần chuyển khoản cho người bán theo số tài khoản mà người bán cung cấp, và đợi người bán xác nhận. Sau khi xác nhận thành công thì USDT sẽ được tự động chuyển cho bạn.',
    '会根据订单信息自动将该笔USDT划入您在': 'USDT sẽ tự động cộng vào tài khoản của bạn theo thông tin đặt hàng',
    '的账户里': 'Trong tài khoản',
    '注意：点击确认即代表您清楚场外USDT入金这一方式并确认过程中自动订单处理系统中的一系列划转过程': 'Lưu ý: Sau khi nhấp vào xác nhận nghĩa là bạn đã chọn phương thức tự động mua USDT từ thị trường ngoài',
    '请确认密码': 'Vui lòng xác nhận mật khẩu',
    '开启': 'Bật',
    '隐藏': 'Ẩn',
    '止盈或止损价格不合理': 'Chốt lãi hoặc cắt lỗ không hợp lí',
    '止盈数据错误': 'Lỗi dữ liệu chốt lãi ',
    '止损数据错误': 'Lỗi dữ liệu cắt lỗ',
    '平台返佣等级不可修改': '平台返佣等级不可修改',
    '取消返佣等级': 'Hủy tầng hoàn trả',
    '没有查询到对应用户': 'Không tìm thấy người dùng tương ứng',
    '审核通过': 'Xét duyệt thông qua',
    '禁止开仓': 'Cấm mở thêm',
    '审核不通过': 'Xét duyệt không thông qua',
    '第': 'Thứ',
    '层': 'Tầng',
    '没有找到下级用户': 'Không tìm ra người dùng cấp dưới',
    '请选择入金状态': 'Mời lựa chọn trạng thái nạp tiền',
    '无': 'Không có',
    '未审核': 'Chưa xét duyệt',
    '审核通过': 'Xét duyệt thông qua',

    "日期": "Ngày tháng",
    '前值': "Giá trước",
    '今值': "Giá hiện tại",
    '预测值': "Giá dự tính",
    '万人': "10000 người",
    '手机号': "Số điện thoại",
    '密码': "Mật khẩu",
    '验证码': "Mã xác nhận",
    '登录': "Đăng nhập",
    '注册': "Đăng kí",
    '忘记密码': "Quên mật khẩu",
    '新密码': "Mật khẩu mới",
    '确认密码': "Xác nhận mật khẩu",
    '获取验证码': "Nhận mã xác nhận",
    '提交': "Gửi lên",
    '清空表单': "Làm mới biểu",
    '推荐码': "Mã mời",
    '邮箱': "Mail",
    '原密码': "Mật khẩu ban đầu",
    '密码长度最小为6位': "Độ dài MK không dưới 6 chữ",
    '两次密码不一致': "2 lần mật khẩu không khớp",
    '邮箱格式不正确': "Định dạng mail không hợp lệ",
    '请输入手机号': "Mời nhập số điện thoại",
    '手机号格式不正确': "Định dạng SĐT không hợp lệ",
    '股票资金流向': "Dòng vốn chứng khoán",
    '中国CPI月报告': "Báo cáo tháng CPI",
    '期货仓单日报': "Báo cáo ngày",
    '美国EIA库存': "Kiểm kê EIA",
    '美联储决议': "Nghị quyết cục dự trữ liên bang",
    '美国非农报告': "Báo cáo ngành phi nông nghiệp MĨ",
    '全球法币热度': "Độ hot tiền Fiat quốc tế",
    '数字货币概览': "Tổng quan về tiền ảo",
    '查看更多': "Xem thêm",
    '操作': "Thao tác",
    '移除自选': "Xóa lựa chọn",
    '统计': "Tổng hợp",
    '金额总计': "Tổng số dư",
    '条目': "Đề mục",
    '提交': "Gửi lên",
    '关闭': "Đóng",
    '姓名': "Họ tên",
    '银行': "Ngân hàng",
    '开户行': "Chi nhánh",
    '银行卡号': "Số tài khoản ngân hàng",
    '金额': "Tổng số dư",
    '转入信息': "Thông tin chuyển vào",
    '订单号': "Số seri đơn",
    '支付方式': "Phương thức thanh toán",
    '状态': "Trạng thái",
    '备注': "Ghi chú",
    '市场快讯': "Bản tin thị trường",
    '财经日历': "Lịch kinh tế",
    '交易排名': "Xếp hạng giao dịch",
    '股票': "Cổ phiếu",
    '指数': "Mục lục",
    '商品': "Mặt hàng",
    '期权': "Tùy chọn",
    '数字货币': "Tiền ảo",
    '法币': "Tiền fiat",
    '时间': "Thời gian",
    '名称': "Tên",
    '交易对': "Cặp giao dịch",
    '最新价': "Giá mới nhất",
    '涨跌幅': "Giá thay đổi",
    '涨跌': "Tăng giảm",
    '涨跌价': "Giá tăng giảm",
    '现价': "Giá hiện tại",
    '买价': "Giá mua",
    '卖价': "Giá bán",
    '买量': "Số lượng mua",
    '卖量': "Số lượng bán",
    '成交量': "Lượng thành giao",
    '成交额': "Doanh số",
    '持仓量': "Lượng đang nắm",
    '日增': "Tăng theo ngày",
    '开盘': "Mở cửa",
    '最高': "Cao nhất",
    '最低': "Thấp nhất",
    '昨收': "Thu hôm trước",
    '交易所': "Lượng giao dịch",
    '代码': "Mã",
    '合约简介': "Giới thiệu hợp đồng",
    '最大交易量': "Số lượng giao dịch lớn nhất",
    '交易量精度': "Số lượng giao dịch chính xác",
    '交易时间': "Thời gian giao dịch",
    '合约大小': "Hợp đồng lớn, nhỏ",
    '最小交易量': "Lượng giao dịch nhỏ nhất",
    '价格精度': "Độ chính xác giá",
    '看涨期权': "Tùy chọn tăng",
    '看跌期权': "Tùy chọn giảm",
    '全部股票': "Toàn bộ cổ phiếu",
    '期权交易': "Quyền giao dịch",
    '请先完成实名认证': "Xác minh danh tính trước",
    '点击认证': "Bấm để xác thực",
    '自选为空': "Tùy chọn trống",
    '首页': "Trang đầu",
    '市场': "Thị trường",
    '自选': "Tùy chọn",
    '资讯': "Thông tin",
    '我的': "Của tôi",
    '请输入查询内容': "Mời nhập thông tin tìm kiếm",
    '行权周期': "Thời gian thực hiện",
    '名义本金': "Tiền gốc",
    '万': "10000",
    '元': "Tệ",
    '手': "đơn vị",
    '预估为': "Ước tính là",
    '类型': "Loại hình",
    '成交方式': "Phương thức giao dịch",
    '始终以当前价格成交': "Luôn mở ở giá trước",
    '限价': "Giá giới hạn",
    '报价比例': "Tỉ lệ báo giá",
    '支付金额': "Số tiền thanh toán",
    '立即认购': "Lập tức mua vào",
    '请输入指定的价格': "Vui lòng nhập giá chỉ định",
    '关闭': "Đóng",
    '提交': "Gửi đi",
    '目标金额': "Số tiền mục tiêu",
    '点击入金': "Bấm để gửi tiền vào",
    '选择入金方式': "Mời chọn phương thức gửi tiền vào",
    '选择出金方式': "Mời chọn phương thức rút tiền ra",
    '入金金额': "Số tiền gửi vào",
    '银联': "Liên ngân hàng",
    '支付宝': "Zhifubao",
    '在线支付': "Thanh toán online",
    '银联': "Liên ngân hàng",
    '比特币': "Bitcoin",
    '场外USDT': "USDT",
    '银联转账': "Chuyển liên ngân hàng",
    '支付': "Thanh toán",
    '注意：需按照订单金额使用本人支付宝账户进行扫码支付': "Lưu ý: Bạn cần sử dụng tài khoản Zhifubao để quét mã để thanh toán theo số lượng đơn hàng",
    '点击出金': "Ấn để rút tiền ra",
    '调整范围': "Chỉnh giới hạn",
    '请输入出金数额': "Mời nhập số tiền rút",
    '请输入正确的数值': "Vui lòng nhập số chính xác",
    '请输入出金数额': "Mời nhập số tiền rút",
    '超过出金限额': "Vượt quá giới hạn rút",
    '交易': "Giao dịch",
    "客户管理": "Quản lí khách hàng",
    "出入金": "Nạp rút tiền",
    "报表查询": "Biểu tìm kiếm",
    "系统设置": "Cài đặt hệ thống",
    "当前权益": "Vốn chủ sở hữu hiện tại",
    "可用资金": "Số tiền có thể dùng",
    "持仓权利金": "Số tiền đang sở hữu",
    "持仓盈亏": "Số lãi lỗ đang sở hữu",
    "当日入金": "Số tiền nạp trong ngày",
    "当日出金": "Số tiền rút trong ngày",
    "二维码开户链接": "Liên kết mở mã QR",
    "出入金设置": "Cài đặt nạp rút tiền",
    "期权认购": "Quyền chọn mua",
    "客户列表": "Danh sách khách hàng",
    "客户行为": "Hành vi khách hàng",
    "异常比赛": "Đơn bất thường",
    "入金": "Nạp tiền",
    "出金": "Rút tiền",
    "入金列表": "Biểu nạp tiền",
    "出金列表": "Biểu rút tiền",
    "委托单": "Đơn vị thế",
    "持仓查询": "Tìm kiếm sở hữu",
    "成交记录": "Lịch sử thành giao",
    "统计报表": "Biểu tổng hợp",
    "资金流水": "Dòng tiền",
    "返佣报表": "Biểu hoàn trả",
    "角色管理": "Vai trò quản lí",
    "组管理": "Quản lí tổ",
    "返佣设置": "Cài đặt hoàn trả",
    "机构管理": "Thể chế quản lí",
    "日志": "Ngày tháng",
    "系统参数": "Hệ thống tham số",
    "子账户": "Tài khoản con",
    "个人信息": "Thông tin cá nhân",
    "修改密码": "Sửa mật khẩu",
    "退出账号": "Đăng xuất tài khoản",
    "净值,": "Giá trị ròng",
    "浮动盈亏,": "Biến động lãi lỗ",
    "余额,": "Số dư",
    "可用余额,": "Số dư khả dụng",
    "保证金,": "Tiền đảm bảo",
    "安全度,": "Độ an toàn",
    "搜索条件": "Điều kiện tìm kiếm",
    "关键词": "Từ liên quan",
    "姓名,邮箱或手机号": "Tên,mail hoặc số điện thoại",
    "选择": "Tùy chọn",
    "品种": "Loại hàng",
    "名称或代码": "Tên hoặc mã",
    "开始时间": "Thời gian bắt đầu",
    "结束时间": "Thời gian kết thúc",
    "额外设置": "Cài đặt bổ sung",
    "是否包括下级": "Đã bao gồm cấp dưới chưa？",
    "委托单类型": "Loại hình vị thế",
    "建仓委托": "Mở vị thế",
    "平仓委托": "Đóng vị thế",
    "已锁定": "Đã khóa",
    "分组": "Phân tổ",
    "下拉选择分组": "Thả xuống để chọn nhóm",
    "市场类型": "Loại hình thị trường",
    "下拉选择市场类型": "Thả xuống để chọn loại hình thị trường",
    "股票": "Cổ phiếu",
    "指数": "Mục lục",
    "商品": "Mặt hàng",
    "提交": "Gửi lên",
    "统计": "Thống kê",
    "用户数": "Số người dùng",
    "权利金": "Tiền lợi",
    "名义本金": "Tiền gốc",
    "条目数": "Số mục vào",
    "场外期权": "Tùy chọn thị trường ngoại địa",
    "场内期权": "Tùy chọn thị trường nội địa",
    "数字货币": "Tiền ảo",
    "确定建仓": "Xác nhận mở vị thế",
    "委托详情": "Chi tiết vị thế",
    "股票代码": "Mã cổ",
    "股票名称": "Tên cổ",
    "权利金比例": "Tỉ lệ tiền lợi ",
    "权利金": "Tiền lợi",
    "到期日期": "Ngày tới hạn",
    "成交方式": "Phương thức giao dịch ",
    "参考价格": "Giá tham khảo",
    "订单": "ĐƠn",
    "建仓价": "Giá mở ",
    "建仓数量": "Số lượng mở",
    "每份期权价格": "Giá mỗi tùy chọn",
    "成交时间": "Thời gian giao dịch",
    "驳回": "Trả về",
    "确定": "Xác nhận",
    "取消": "Hủy",
    "建仓数量": "Số lượng mở",
    "建仓数量": "Số lượng mở",
    "确定平仓": "Xác nhận đóng",
    "委托详情": "Chi tiết mở",
    "选择用户": "Tùy chọn người dùng",
    "保存": "Lưu",
    "取消": "Hủy",
    "委托单": "Vị thế",
    "平仓价": "Giá đóng",
    "数量": "Số lượng",
    "委托单": "Vị thế",
    "名义本金": "Gốc",
    "成交额": "Số tiền giao dịch",
    "期权类型": "Loại hình tùy chọn ",
    "方向": "Phương hướng",
    "权利金": "Tiền lợi",
    "手续费": "Tiền phí giao dịch",
    "表单不完整": "Biểu không đầy đủ",
    "修改": "Sửa",
    "平仓": "Đóng",
    "撤委": "Hủy",
    "止盈": "Chốt lãi",
    "止损": "Chốt lỗ",
    "确认": "Xác nhận",
    "关闭": "Đóng",
    "交易": "Giao dịch",
    "市场深度": "Độ sâu thị trường",
    "最高": "Cao nhất",
    "最低": "Thấp nhất",
    "成交量": "Số lượng thành giao",
    "今开": "Mở hôm nay",
    "昨收": "Thu hôm qua",
    "成交额": "Số giao dịch",
    "持仓量": "Lượng sở hữu",
    "买一": "Mua 1 ",
    "卖一": "Bán 1",
    "日增": "Tăng trong ngày",
    "净值": "Giá ròng",
    "保证金": "Tiền bảo đảm ",
    "可用余额": "Số dư khả dụng",
    "浮动盈亏": "Biến động lãi lỗ",
    "安全度": "Độ an toàn",
    "手数": "Số đơn vị",
    "手": "Đơn vị",
    "市价": "Giá thị trường",
    "对手价": "Giá cặp đơn vị",
    "价格": "Giá",
    "可开": "Có thể mở",
    "可平": "Có thể đóng",
    "每手保证金": "Tiền đảm bảo mỗi đơn vị",
    "价格": "Giá",
    "买多": "Mua nhiều",
    "卖空": "Bán ngắn hạn",
    "平仓": "Đóng",
    "登录": "Đăng nhập",
    "注册": "Đăng kí",
    "持仓": "Sở hữu",
    "委托": "Vị thế",
    "成交": "Thành giao",
    "合约名称": "Tên hợp đồng",
    "多空": "Dài , ngắn",
    "交易量": "Số lượng giao dịch",
    "开仓价": "Giá mở cửa",
    "开仓时间": "Thời gian mở cửa",
    "手续费": "Tiền phí giao dịch",
    "库存费": "Phí kiểm kê",
    "盈亏": "Lãi lỗ",
    "操作": "Thao tác",
    "平仓": "Đóng ",
    "撤委": "Hủy",
    "委托价": "Giá vị thế",
    "委托时间": "Thời gian giao phó",
    "开仓价": "Giá mở cửa",
    "开仓时间": "Thời gian mở cửa",
    "市场深度": "Độ sâu thị trường",
    "买": "Mua",
    "卖": "Bán",
    "平仓价": "Giá đóng",
    "平仓时间": "Thời gian đóng",
    "多": "Dài hạn",
    "空": "Ngắn hạn",

    '身份证照正面': "Ảnh mặt trước chứng minh thư",
    '点击上传': "ấn để tải lên",
    '身份证照背面': "Ảnh mặt sau chứng minh thư",
    '所在地区': "Khu vực trực thuộc",
    '开户支行': "chi nhánh mở tài khoản",
    '银行卡照片': "Ảnh thẻ ngân hàng",
    '法律声明': "Thông tin pháp lí",
    '已阅读': "Đã đọc kĩ điều khoản",
    '用户协议': "Thỏa thuận người dùng",
    '关于反洗钱': "Chi tiết về chống rửa tiền",
    '已同意': "Đã đồng ý",
    '立即创建': "Tạo ngay bây giờ ",
    '重置': "Đặt lại",

    '输入不能为空': 'Không được để trống',
    '合计': 'Toàn bộ',
    '手': 'đơn vị',
    '万手': '100k',
    '亿': '100m',
    '未开通此功能，请联系管理员': 'Tính năng này chưa được kích hoạt, vui lòng liên hệ quảng trị viên',

    '产品规格': "Thông số kỹ thuật sản phẩm",
    '最近浏览': "Đã xem gần đây",
    '市场深度': "Thị trường",
    '自选列表': "Danh sách tùy chọn",
    '下载客户端': "Tải xuống ứng dụng khách",
    '确认密码与新密码不一致': "Mật khẩu đã xác nhận khớp với mật khẩu mới",
    '字段不能为空': "Phần này không được để trống",
    '手机号格式不正确': "Định dạng số điện thoại di động không chính xác",
    '请输入手机号': "Vui lòng nhập số điện thoại của bạn",
    '获取验证码': "Nhận mã xác minh",
    '邀请码不能为空': "Mã lời mời không được để trống",
    '密码不能为空': "Mật khẩu không được để trống",
    '确认密码不能为空': "Xác nhận mật khẩu không được để trống",
    '手机号不能为空': "Số điện thoại di động không được để trống",
    '验证码不能为空': "Mã xác minh không được để trống",
    '手机号为空': "Chưa điền số điện thoại di động",
    '剩余': "Số dư còn lại",
    '秒': "Giây",
    '获取验证码': "Nhận mã xác minh",
    '关键词不能为空': "Từ khóa không được để trống",
    '搜索条件': "Điều kiện tìm kiếm",
    '关键词': "Từ khóa",
    '不能为空': "Không được để trống",
    '未读消息': "Chưa đọc thông tin",
    '条': "Danh sách",

    '请输入密码': "Vui lòng nhập mật khẩu của bạn",
    '请输入验证码': "Vui lòng nhập mã xác minh",
    '我的': "Của tôi",
    '已审核': "đã xét duyệt",
    '未审核': "Chưa đc xét duyệt",
    '成功': "Thành công",
    '驳回': "Bị từ chối",
    '优先资金': "Nguồn vốn Ưu tiên",
    '提交': "Thông số sản phẩm",
    '手机号,邮箱,姓名': "Số di động, Mail, Họ tên",
    '账户转账': "Tài khoản chuyển khoản",
    '关键词': "Từ khóa",
    '数额': "Số tiền",
    '关闭': "Đóng",
    '提交': "Gửi đi",
    '表单不完整': "Biểu không hoàn chỉnh",
    '出金方式': "Phương thức rút tiền",
    '备注': "Ghi chú",
    '操作': "Thao tác",
    '订单号': "Số đơn hàng",
    '姓名': "Họ tên",
    '实名状态': "Trạng thái tên thật",
    '创建时间': "Thời gian tạo",
    '角色': "Vai trò",

    '余额': "Số dư",
    '账户状态': "Trạng thái tài khoản",
    '账户状态': "Trạng thái tài khoản",
    '手机号': "Số điện thoại",
    '分组': "Chia nhóm",
    '商品名称': "Tên sản phẩm",
    '商品代码': "Mã sản phẩm",
    '委托数量': "Số đơn Ủy thác",
    '成交额': "Doanh số",
    '方向': "Phương hướng",
    '手续费': "Tiền phí giao dịch",
    '建仓价': "Giá mở cửa",
    '委托建仓时间': "Thời gian mở vị trí ủy thác",
    '建仓时间': "Thời gian mở cửa",
    '建仓方式': "Phương thức mở",
    '平仓价': "Giá đóng cửa",
    '平仓时间': "Thời gian đóng cửa",
    '委托平仓时间': "Thời gian đóng vị trí ủy thác",
    '平仓方式': "Phương thức đóng cửa",
    '净盈亏': "Lãi lỗ",
    '平仓类型': "Loại hình đóng cửa",
    '到期日期': "Ngày hết hạn",
    '市场类型': "Loại hình thị trường",
    '所属机构': "Cơ chế chi nhánh",

    '委托类型': "Loại ủy thác",
    '建仓委托': "Mở 1 ủy thác ",
    '平仓委托': "Chốt lệnh ủy thác",
    '收盘均价': "Giá đóng cửa trung bình",
    '市价': "Giá thị trường",
    '限价': "Giá giới hạn",
    '时段均价': "Giá trung bình theo thời gian",
    '邮箱或手机号': "Mail hoặc số điện thoại",
    '名称或代码': "Tên hoặc là mã người dùng",
    '搜索条件': "Điều kiện tìm kiếm",
    '关键词': "Từ liên quan",
    '品种': "Đa dạng",
    '开始时间': "Thời gian bắt đầu",
    '结束时间': "Thời gian kết thúc",
    '额外设置': "Cài đặt bổ sung",
    '是否包括下级': "Đã hay không bao gồm cấp dưới",
    '分组': "Chia nhóm",
    '下拉选择分组': "Kéo xuống để chọn nhóm",
    '提交': "Gửi đi",
    '统计': "Thống kê",
    '用户数': "Số người dùng",
    '买入数量': "Số lượng mua vào",
    '卖出数量': "Số lượng bán ra",
    '成交额': "Doanh số",
    '手续费': "Tiền phí giao dịch",
    '库存费': "Phí kiểm kê tồn kho ",
    '条目': "Đề mục",
    '浮动盈亏': "Biến động lãi lỗ",
    '平仓': "Đóng đơn",
    '平仓设置': "Đóng cài đặt",
    '订单ID': "mã đơn",
    '股票代码': "Mã cổ phiếu",
    '股票名称': "Tên cổ phiếu",
    '平仓数量': "Số lượng đóng",
    '平仓交易方式': "Phương thức đóng",
    '请选择平仓方式': "Vui lòng chọn phương thức đóng",
    '平仓价': "Giá đóng cửa",
    '选择用户': "Lựa chọn người dùng",
    '保存': "Lưu",
    '取消': "Hủy",
    '交易详情': "Chi tiết giao dịch",
    '概览': "Tổng quát",
    '持仓查询': "Truy vấn vị trí ",
    '库存费': "Phí kiểm kê tồn kho",
    '当前价': "Giá trước đó",
    '浮动盈亏': "Biễn động lãi lỗ",
    '买入': "Mua vào",
    '卖出': "Bán ra",
    '平仓': "Đóng ",
    '驳回': "Giảm xuống",
    '撤委': "Hủy bỏ",
    '修改个人信息': "Chỉnh sửa thông tin cá nhân",
    '修改邮箱': "Chỉnh sửa thông tin mail",
    '修改手机号': "chỉnh sửa số điện thoại",
    '实名认证': "Xác nhận danh tính",
    '已经实名': "Đã xác nhận danh tính",
    '柜台账号': "Tài khoản truy cập",
    '姓名': " Họ tên",
    '未实名': "Tên nguyên bản",
    '身份证正面照片': "Ảnh chụp chính diện mặt trước cmt",
    '身份证背面照片': "Ảnh chụp chính diện mặt sau cmt",
    '银行卡号': "Số tài khoản ngân hàng",
    '银行卡信息': "Thông tin ngân hàng",
    '银行卡照片': "Ảnh thẻ ngân hàng",
    '法律声明': "Thông báo Pháp lí ",
    '用户协议': "Thỏa thuận người dùng",
    '关于反洗钱': "Về chống rửa tiền",
    '已阅读': "Đã đọc",
    '未阅读': "Chưa đọc",
    '已同意': "Đã đồng ý",
    '未同意': "Chưa đồng ý",
    '清空表单': "Hình thức rõ ràng",
    '修改邮箱': "sửa thông tin mail",
    '身份证真人活体检测比对': "So sánh ảnh cmt và người thật ",
    '用手机扫描二维码以进行本人身份证真人活体检测比对': "Quét mẫ QR để xác nhận so sánh cmt và người thật",
    '密码长度最小为6位': "Mật khẩu cần tối thiểu 6 kí tự",
    '邮箱': "Mail",
    '身份证号': "ID",
    language: "VIETNAMESE",
    '姓名': "Họ tên",
    '银行': "Ngân hàng",
    '开户行': "Tên ngân hàng",
    '银行卡号': "Số tài khoản ngân hàng",
    '金额': "Số tiền",
    '转入信息': "Thông tin chuyển ",
    '订单号': "Mã giao dịch",
    '支付方式': "Phương thức thanh toán",
    '状态': "Trạng thái",
    '时间': "Thời gian",
    '备注': "Ghi chú",
    jin10: {
        a1: "Ngày tháng",
        a2: "Giá hôm trước ",
        a3: "Giá hôm nay",
        a4: "Giá dự tính",
        a5: "10K",
    },

    logReg: {
        a1: "Số điện thoại",
        a2: "Mật mã",
        a3: "Mã xác nhận",
        a4: "Đăng nhập",
        a5: "Đăng kí",

        b1: "Quên mật khẩu",
        b2: "Mật khẩu mới",
        b3: "Xác nhận mật khẩu",
        b4: "Số điện thoại",
        b5: "Mã xác nhận",
        b6: "Lấy mã xác nhận",
        b7: "Xác nhận gửi lên",
        b8: "Xóa biểu mẫu",

        c1: "Mã giới thiệu",
        c2: "Hòm thư điện tử",

        d1: "Mật khẩu ban đầu",
    },

    fourReport: {
        flow: "Dòng tiền đầu tư ",
        report: "Trung Quốc CPI báo cáo tháng",
        daily: " báo cáo ngày",
        store: " Kho EIA",

        a1: "Nghị quyết cục liên bang",
        a2: "Báo cáo ngành phi nông sản của Mĩ",
        a3: " Độ HOT tiền tệ Fiat toàn cầu",
        a4: "Tổng quan về tiền ảo",
    },
    seeMore: "Xem nhiều hơn",
    action: "Thao tác",
    delFav: "Xóa lựa chọn",
    statistical: "Thống kê",
    totalMoney: "Tổng số tiền",
    listNum: "Danh sách mục",
    submit: "Xác nhận gửi lên",
    close: "Đóng",
    moneyTable: {
        name: "Họ tên",
        bank: "Ngân hàng",
        open_bank: "Tên ngân hàng",
        card_code: "Số tài khoản ngân hàng",
        money: "Số tiền",
        info_d: "Thông tin chuyển ",
        id: "Mã giao dịch",
        way_d: "Phương thức thanh toán",
        status: "Trạng thái",
        time: "Thời gian",
        msg: "Ghi chú",
    },
    news: {
        quick: "Thị trường giao dịch nhanh",
        calendar: "Lịch trình tài chính",
        rank: " Xếp hạng giao dịch",
    },
    tradeSymbol: {
        stock: "Cổ phiếu",
        index: "Mục lục",
        goods: "Hàng hóa",
        options: "Tùy chọn",
        bitcoin: "Tiền ảo",
        money: "Tiền tệ Fiat",
    },
    homeTable: {
        updated_datetime: "Thời gian cập nhật",
        name: "Tên",
        name_pair: " Cặp giao dịch",
        latest_p: " Giá mới nhất",
        up_range: " Ngưỡng  tăng giảm",

        up_number: "Số lượng tăng giảm",
        up_number_a: "Giá thay tăng giảm",

        now_p: "Giá hiện tại",
        buy_p: "Giá mua",
        sale_p: "Giá bán",
        buy_v: "Lượng mua",
        sale_v: "Lượng bán",
        deal_v: "Khối lượng giao dịch thành công",
        money: "Số tiền giao dịch thành công",
        hold_v: "Khối lượng chờ giao dịch",
        dayRise: "Ngày tăng",
        open: "Mở sàn",
        high: "Cao nhất",
        low: "Thấp nhất",
        close: "Nhận hôm qua",
        exchange: "Khóa giao dịch",
        symbol: "Mã số",

        contract_intro: "Giới thiệu hợp đồng",
        max_volume: "Khối lượng giao dịch tối đa",
        amount_precision: "Số lượng giao dịch chính xác",
        sale_datetime: "Thời gian giao dịch",
        contract_size: "Quy mô hợp đồng",
        min_volume: "Lượng giao dịch thấp nhất",
        price_precision: "Giá chính xác",
    },
    option: {
        up: "Quyền xem giá tăng",
        down: "Quyền xem giá giảm",
    },
    bannerTitle: {
        allStock: "Toàn bộ cổ phiếu",
        Subscribed: "Tùy chọn giao dịch",
    },
    notice: {
        realAuth: "Vui lòng hoàn thành xác thực tên thật trước",
        realAuth2: "Vui lòng hoàn thành xác thực tên thật trước",
        confirm: " Nhấn để xác nhận",
        noFavorite: "Không có yêu cầu",
    },
    footer: {
        home: "Trang đầu",
        market: "Thị trường",

        optional: "Chọn",
        news: "Thông tin",
        mine: "Của tôi",
    },
    mine: {
        nav: {
            Deal: "Giao dịch",
            CustomerManagement: "Quản lí khách hàng",
            WithdrawDeposite: "Gửi, rút tiền",
            ReportQuery: "Biểu tìm kiếm",
            SystemConfig: "Cài đặt hệ thống",
        },
        currentEquity: "Vốn chủ sở hữu",
        balance: "Tiền có thể dùng",
        premium: "Tiền  thưởng đặc biệt",
        positiongl: "Lãi lỗ",
        todayDeposit: "tiền chuyển vào trong ngày",
        todayWithdraw: "Tiền rút ra trong ngày",

        qrcode: "Mã QR",
        sideMenu: {
            SettingInOut: "Cài đặt nạp rút tiền",
            Subscribed: "Quyền đặt mua",
            ListClientAdmin: "Danh sách khách hàng",
            CustomerAction: "Hành động của khách hàng",
            UnnormalMatch: "Giao dịch bất thường",

            Deposite: "Nạp tiền",
            Withdraw: "Rút tiền",
            UnCheckDeposite: "Biểu lịch sử nạp tiền",
            UnCheckWithdraw: "Biểu lịch sử rút tiền",

            DelegateOrder: "Lệnh ủy quyền",
            RecordPosition: "Vị trí tìm kiếm",
            RecordTrade: "Lịch sử giao dịch thành công",
            RecordStatistics: "Biểu đồ tống kê",
            BillDetail: "Dòng tiền",
            RecordCommission: "Biểu tiền hoàn trả",

            SettingRole: "Vai trò quản lí",
            SettingGroup: " Nhóm quản lí",
            SettingRank: "Cài đặt hoàn trả",
            SettingOrg: "Thể chế quản lí",
            RecordLog: " Nhật kí",
            SettingSystem: "Tham số hệ thống",
            SettingNotice: "Quản lí thông báo",

            SubAccount: "Tài khoản con",
            Profile: "Thông tin cá nhân",
            pwdChange: "Sửa đổi mật khẩu",

            logout: " Đăng xuất tài khoản",
        },
        a1: "Giá trị ròng",
        a2: "Biến động lãi lỗ",
        a3: "Số dư",
        a4: "Số dư có thể dùng",
        a5: "Số tiền đảm bảo",
        a6: "Mức độ an toàn",
    },
    Subscribed: {
        search: " Mời nhập nội dung cần tìm",
        cycle: "Thời gian thực hiện",
        notional: "tiền gốc ",
        wan: "1 vạn",
        yuan: "Nhân Dân Tệ",
        hand: "Tay",
        about: "Ước tinh là",
        type: "Loại hình",
        dealway: "Phương thức giao dịch",
        alwaysNow: " Luôn giao dịch ở mức giá ban đầu",
        limitPrice: "Giá giới hạn",
        premium_ratio: "Tỉ lệ báo giá",
        payPrice: "Số tiền thanh toán",
        buy: "Đặt mua ngay",
        setMoney: "Vui lòng nhập giá đã chỉ định",
        close: "Đóng",
        submit: "Gửi lên",
    },
    deposite: {
        a1: "Số tiền mục tiêu",
        doDeposite: "Ấn vào để nạp tiền ",

        setWay: "Mời chọn hình thức nạp tiền",
        setWay2: " Mời chọn hình thức rút tiền",
        hint: "Số tiền nạp",

        wayList: {
            Transfer: "Liên ngân hàng",
            Alipay: "Zhifubao",
            QuFuBao: "Giao dịch online",
            Transfer1: "Liên ngân hàng",
            Bitcoin: "Bitcoin",
            Otcusdt: "USDT",

            Unionpay: "chuyển khoản ngân hàng",

        },

        pay: "Thanh toán",
        zfbNotice: "Chú ý : bạn cần dùng tài khoản zhifubao quét mã và thanh toan theo số lượng yêu cầu",
    },
    withdraw: {
        doWithdraw: " Ấn để rút tiền",
        setRange: " Phạm vi điều chỉnh",
        hint: "Mời nhập số tiền muốn rút",

        notice_a: " Mời nhập chinh xác số lượng",
        notice_b: "Mời nhập số tiền muốn rút",
        notice_c: " Vượt quá giới hạn rút tiền",
    },
    DelegateOrder: {
        a1: "Điều kiện tìm kiếm",
        a2: " Từ có liên quan",
        a3: "Họ tên, mail hoặc số điện thoại",
        a4: "Lựa chọn",
        a5: "Đa dạng",
        a6: "Tên hoặc mã",
        a7: " Thời gian bắt đầu",
        a8: "Thời gian kết thúc",
        a9: "Cài đặt bổ sung",
        a10: "Có hay không bao gồm cấp dưới",
        a11: "Loại đơn lệnh",
        a12: " Mở lệnh",
        a13: "Chốt lệnh",
        a14: " Đã khóa",
        a15: "chia nhôm",
        a16: " Thả xuống để chọn nhôm",

        a17: "Loại hình thị trường",
        a18: "Thả xuống để chọn loại thị trường",
        a19: "Cổ phiếu",
        a20: "Chỉ số",
        a21: "Mặt hàng",
        a22: "Gửi lên",

        b1: "tổng hợp",
        b2: "Số người dùng",
        b3: "Tiền thưởng",
        b4: "Tiền gốc danh nghĩa",
        b5: " Số mục nhập",
        b6: "Tùy chọn sàn ngoài",
        b7: "Tùy chọn sàn nội địa",
        b8: "Tiền ảo",

        c1: "Xác nhận mở",
        c2: "Chi tiết hoa hồng",
        c3: "Mã cổ phiếu",
        c4: "Tên cổ phiếu",
        c5: "Tỉ lệ tiền thưởng",
        c6: "Tiền thưởng",
        c7: "Ngày hết hạn",
        c8: "Phương thức giao dịch",
        c9: "Giá tham khảo",

        c11: "Đơn ID",
        c12: "Giá mở",
        c13: "Số lượng mở",
        c14: "Mỗi phần giá tùy chọn",
        c15: "Thời gian giao dịch",
        c16: "Giảm",
        c17: " Xác nhận",
        c18: "Hủy",
        c19: "Số lượng mở",
        c20: "Số lượng mở",
        c21: "Xác định đóng",
        c22: "Chi tiết ủy quyền",
        c23: "Chọn người dùng",
        c24: "Lưu",
        c25: "Hủy",
        c26: "Đơn mở",
        c27: "Giá đóng",
        c28: "Số lượng",

        d1: "Đơn mở",
        d2: "Tiền gốc danh nghĩa",
        d3: "Số đặt lệnh",
        d4: "Các tùy chọn",
        d5: "Hướng đi",
        d6: "Tiền thưởng",
        d7: "Tiền thủ tục",
        d8: "Biểu không đầy đủ",
    },
    BitcoinTrading: {
        positionAction: {
            a1: "Sửa đổi ",
            a2: "đóng",
            a3: "Hủy bỏ",
            a4: "Chốt lãi",
            a5: "Chốt lỗ",
            a6: "Xác nhận",
            a7: "Đóng",
        },
        a1: "Giao dịch",
        a2: "Thị trường",

        b1: " Cao nhất",
        b2: "Thấp nhất",
        b3: "Lượng giao dịch",
        b4: "Mở hôm nay",
        b5: "Mở hôm qua",
        b6: "Khối lượng đặt lệnh",
        b7: "Lượng mở",
        b8: " Mua 1",
        b9: "Bán 1",
        b10: "Lên của ngày",

        c1: "Giá ròng",
        c2: "Tiền đảm bảo",
        c3: "Số dư có thể dùng",
        c4: "Biến động lãi lỗ",
        c5: "Độ án toàn",

        d1: "Số tay",
        d2: "Tay",
        d3: "Giá thị trường",
        d4: "Giá đối thủ cạnh tranh",
        d5: "Giá",

        d6: "Có thể mở",
        d7: "Có thể cân bằng",
        d8: "Bảo đảm cho mõi tay",
        d9: "Giá",
        d10: "Mua nhiều",
        d11: "Mua trống",
        d12: "Đóng lệnh",
        d13: "Đăng nhập",
        d14: "Đăng kí",

        e1: "Nắm giữ ",
        e2: "Giao phó",
        e3: "Thành công",

        e4: "Tên hợp đồng",
        e5: "Trống nhiều",
        e6: "Số lượng giao dịch",
        e7: "Giá mở",
        e8: "Thời gian mở",
        e9: "Tiền phí thủ tục",
        e10: "Phí tồn kho",
        e11: "Lỗ lãi",
        e12: "Thao tác",
        e13: "Đóng lệnh",
        e14: "Hủy bỏ",

        e15: "Giá hoa hồng",
        e16: "Thời gian",

        ee15: "Giá mở",
        ee16: "Thời gian mở",

        e17: "Độ sâu của thị trường",
        e18: "Mua",
        e19: "Bán",
        e20: "Giá đóng cửa",
        e21: "Thời gian đóng cửa",

        f1: "Nhiều",
        f2: "Trống",
    }
};

export default vi;


// WEBPACK FOOTER //
// ./src/i18n/config/vi.js